(() => {
  function initHero(root) {
    // ★二重初期化防止（これがないとタイマーが増殖して早くなる）
    if (root.dataset.heroInited === "1") return;
    root.dataset.heroInited = "1";

    const track = root.querySelector("[data-hero-track]");
    const bullets = Array.from(root.querySelectorAll("[data-hero-bullet]"));
    if (!track || bullets.length === 0) return;

    const slides = Array.from(root.querySelectorAll("[data-hero-slide]"));
    let index = 0;
    let timer = null;

    function setActive(i) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      bullets.forEach((b, bi) => {
        const active = bi === index;
        b.classList.toggle("is-active", active);
        b.setAttribute("aria-current", active ? "true" : "false");
      });
    }

    function go(i) {
      setActive(i);
      const x = track.clientWidth * index;
      track.scrollTo({ left: x, behavior: "smooth" });
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function start() {
      if (slides.length <= 1) return;
      stop(); // ★重要：既存タイマーを必ず止めてから開始（増殖防止）
      timer = setInterval(() => {
        const next = (index + 1) % slides.length;
        go(next);
      }, 4500);
    }

    // bullet click
    bullets.forEach((b, i) => {
      b.addEventListener("click", () => {
        stop();
        go(i);
        start();
      });
    });

    // sync on scroll (snap)
    let raf = null;
    track.addEventListener("scroll", () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(i);
      });
    });

    // ===== ここから：ドラッグ対応（誤クリック防止つき） =====
    let isDown = false;
    let startX = 0;
    let startLeft = 0;
    let dragged = false;
    let blockClickUntil = 0;

    track.addEventListener("pointerdown", (e) => {
      if (e.button !== undefined && e.button !== 0) return;
      isDown = true;
      dragged = false;
      startX = e.clientX;
      startLeft = track.scrollLeft;
      stop();
      track.setPointerCapture?.(e.pointerId);
    });

    track.addEventListener("pointermove", (e) => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 6) dragged = true;
      track.scrollLeft = startLeft - dx;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;

      if (dragged) {
        blockClickUntil = Date.now() + 250;
        const i = Math.round(track.scrollLeft / track.clientWidth);
        go(i);
      }
      start();
    }

    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);

    // ドラッグ直後のリンク誤クリックを無効化（キャプチャ）
    track.addEventListener(
      "click",
      (e) => {
        if (Date.now() < blockClickUntil) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
    // ===== ここまで：ドラッグ対応 =====

    // init
    setActive(0);
    start();

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);

    // セクション破棄時に止められるよう保持（テーマ編集用）
    root.__heroStop = stop;
  }

  function boot(container = document) {
    container.querySelectorAll("[data-shampo-home-top]").forEach(initHero);
  }

  document.addEventListener("DOMContentLoaded", () => boot());

  // ★テーマエディタでの再読み込み対策
  document.addEventListener("shopify:section:load", (e) => boot(e.target));
  document.addEventListener("shopify:section:unload", (e) => {
    const root = e.target.querySelector("[data-shampo-home-top]");
    if (root && root.__heroStop) root.__heroStop();
    if (root) root.dataset.heroInited = "0";
  });
})();

(() => {
  function initSearchCategory(root){
    const tabCategory = root.querySelector('[data-shampo-tab="category"]');
    const tabBrand = root.querySelector('[data-shampo-tab="brand"]');
    const tabHome = root.querySelector('[data-shampo-tab="home"]');

    const pageCategory = root.querySelector('[data-shampo-page="category"]');
    const pageBrand = root.querySelector('[data-shampo-page="brand"]');

    if(!tabCategory || !tabBrand || !tabHome || !pageCategory || !pageBrand) return;

    let openKey = null; // 'category' | 'brand' | null

    function setSelectedTab(key){
      root.querySelectorAll('.tab-label').forEach(el => el.classList.remove('is-selected'));
      const el = root.querySelector(`[data-shampo-tab="${key}"] .tab-label`);
      if(el) el.classList.add('is-selected');
    }

    function closeAll(){
      openKey = null;

      pageCategory.classList.remove('is-open');
      pageBrand.classList.remove('is-open');
      pageCategory.setAttribute('aria-hidden', 'true');
      pageBrand.setAttribute('aria-hidden', 'true');

      // タブの見た目：閉じたら HOME をselectedにする（要件）
      setSelectedTab('home');
    }

    function openPanel(key){
      // 同じタブを押したらトグルで閉じる
      if(openKey === key){
        closeAll();
        return;
      }

      openKey = key;

      // まず全部閉じてから対象だけ開く
      pageCategory.classList.remove('is-open');
      pageBrand.classList.remove('is-open');
      pageCategory.setAttribute('aria-hidden', 'true');
      pageBrand.setAttribute('aria-hidden', 'true');

      if(key === 'category'){
        pageCategory.classList.add('is-open');
        pageCategory.setAttribute('aria-hidden', 'false');
        setSelectedTab('category');
      }
      if(key === 'brand'){
        pageBrand.classList.add('is-open');
        pageBrand.setAttribute('aria-hidden', 'false');
        setSelectedTab('brand');
      }
    }

    // タブクリック
    tabCategory.addEventListener('click', () => openPanel('category'));
    tabBrand.addEventListener('click', () => openPanel('brand'));

    // HOMEは「閉じる」だけ（遷移しない仕様に変更）
    tabHome.addEventListener('click', () => closeAll());

    // アコーディオン（カテゴリ内）
    root.querySelectorAll('[data-shampo-acc]').forEach(cat => {
      const head = cat.querySelector('[data-shampo-acc-head]');
      if(!head) return;

      head.addEventListener('click', () => {
        // 1つだけ開く
        root.querySelectorAll('[data-shampo-acc].is-open').forEach(other => {
          if(other !== cat) other.classList.remove('is-open');
        });
        cat.classList.toggle('is-open');

        // aria-hidden を合わせる
        cat.querySelectorAll('[data-shampo-acc-item]').forEach(item => {
          item.setAttribute('aria-hidden', cat.classList.contains('is-open') ? 'false' : 'true');
        });
      });

      // 初期は必ず閉じ
      cat.classList.remove('is-open');
      cat.querySelectorAll('[data-shampo-acc-item]').forEach(item => item.setAttribute('aria-hidden', 'true'));
    });

    // ✅ 初期表示は「閉じた状態」＋ HOME selected
    closeAll();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-shampo-search-category]').forEach(initSearchCategory);
  });
})();
